/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownInCircleEmpty: {
  name: 'arrow-down-in-circle-empty';
  data: string;
} = {
  name: 'arrow-down-in-circle-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM8.5 5a.5.5 0 0 0-1 0v4.793L6.354 8.646a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.793V5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
